/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PrognoseGruppeTyp } from './PrognoseGruppeTyp';
import {
    PrognoseGruppeTypFromJSON,
    PrognoseGruppeTypFromJSONTyped,
    PrognoseGruppeTypToJSON,
} from './PrognoseGruppeTyp';

/**
 * 
 * @export
 * @interface FuePrognoseGruppeZuZeitpunkt
 */
export interface FuePrognoseGruppeZuZeitpunkt {
    /**
     * 
     * @type {PrognoseGruppeTyp}
     * @memberof FuePrognoseGruppeZuZeitpunkt
     */
    prognoseGruppeTyp: PrognoseGruppeTyp;
    /**
     * 
     * @type {string}
     * @memberof FuePrognoseGruppeZuZeitpunkt
     */
    zeitpunkt: string;
}

/**
 * Check if a given object implements the FuePrognoseGruppeZuZeitpunkt interface.
 */
export function instanceOfFuePrognoseGruppeZuZeitpunkt(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prognoseGruppeTyp" in value;
    isInstance = isInstance && "zeitpunkt" in value;

    return isInstance;
}

export function FuePrognoseGruppeZuZeitpunktFromJSON(json: any): FuePrognoseGruppeZuZeitpunkt {
    return FuePrognoseGruppeZuZeitpunktFromJSONTyped(json, false);
}

export function FuePrognoseGruppeZuZeitpunktFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuePrognoseGruppeZuZeitpunkt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prognoseGruppeTyp': PrognoseGruppeTypFromJSON(json['PrognoseGruppeTyp']),
        'zeitpunkt': json['zeitpunkt'],
    };
}

export function FuePrognoseGruppeZuZeitpunktToJSON(value?: FuePrognoseGruppeZuZeitpunkt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PrognoseGruppeTyp': PrognoseGruppeTypToJSON(value.prognoseGruppeTyp),
        'zeitpunkt': value.zeitpunkt,
    };
}

